import type { UncappedCrestSource } from 'app/frontend/types/custom/Season'

type CrestCapSource = {
  first_period: number
  weekly_increase: number
  uncapped_crests?: Record<string, UncappedCrestSource>
}

export const uncappedCrestTotal = (crest: CrestCapSource): number =>
  Object.values(crest.uncapped_crests ?? {}).reduce(
    (sum, source) => sum + source.amount,
    0,
  )

export const weeklyCrestCap = (
  crest: CrestCapSource,
  currentPeriod: number,
): number =>
  Math.max(0, currentPeriod - crest.first_period + 1) * crest.weekly_increase

export const weeklyCrestEarned = (
  earned: number,
  weeklyCap: number,
  earnedSources: Record<string, number>,
): number => {
  const uncappedEarned = Object.values(earnedSources).reduce(
    (sum, amount) => sum + amount,
    0,
  )
  return Math.min(weeklyCap, Math.max(0, earned - uncappedEarned))
}

export const crestEarnableCap = (
  crest: CrestCapSource,
  currentPeriod: number,
): number => weeklyCrestCap(crest, currentPeriod) + uncappedCrestTotal(crest)
